export const prices = {
  club: 0,
  contrastoColletto: 0,
  contrastoPolsino: 0,
  contrastoChiusura: 0,
  iniziali: 0,
  mascherina: 5,
};

export const owner = {
  lang: "it",
  appName: "3D Shirt",
  appUrl: "https://sumisura.netlify.app//",
  azienda: "Maffini Valter Luigi",
  attenzione: "Maffini Valter Luigi",
  indirizzo: "Via Toscana, 2",
  citta: "Cornegliano Laudense",
  provincia: "Lodi",
  cap: "26854",
  email: "sumisuraweb@gmail.com",
  telefono: "+39 327 112 2035",
  piva: "11906560963",
  registroDi: "Lodi",
  foro: "Lodi",
  gdpr: {
    titolare: "Maffini Valter Luigi",
    email: "sumisuraweb@gmail.com",
    data: "10 Ottobre 2022",
  },
  social: {
    facebook: "",
    twitter: "",
    whatsapp: "https://api.whatsapp.com/send?phone=393271122035",
  },
};
